import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
export const CategoryCard = styled.div`
  background-color: white;
  height: 230px;
  max-width: 230px;
  min-width: 230px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
  overflow: hidden;
  transition: transform .25s ease-in-out;
  cursor: pointer;
  &:hover{
    transform: scale(1.05); 
}
  img{
      max-width: 100%;
      width: 100%;
      height: 190px;
      object-fit: cover;
    }
`;

export const Title = styled.div`
    position: absolute;
    width: 230px;
    font-size: 25px;
    line-height: 1.5rem;
    margin-top: 10px;
    margin-bottom: 10px;
    text-transform: capitalize;
    word-wrap: break-word;
    font-weight: 400;
    color: ${themeGet("colors.primary", "#9cc54b")};

    .boldDark {
      text-transform: uppercase;
      color: #000;
      font-weight: 700;
    }

`;

export const WelLink = styled.a`
  &:hover {
    text-decoration: none;
  }
`

export const ImageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
`